<script setup lang="ts">
defineProps<{
  id: number;
}>();
</script>

<template>
  <i18n-t
    keypath="core.counterparty.notification.success.add"
    tag="span"
  >
    <template #link>
      <a
        class="_hover _extra"
        :href="`/client/${id}`"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ id }}
      </a>
    </template>
  </i18n-t>
</template>
